import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import { CardTitle, CardText, CardActions } from 'react-toolbox/lib/card';
import {Button} from '../../../../../common/components';
import AssociationForm from './AssociationForm';

const CustomCardTitle = glamorous(CardTitle, {
  rootEl: 'div',
  forwardProps: Object.keys(CardTitle.propTypes),
})({
  paddingTop: '0.6rem !important',
  '& div': { width: '100%' },
});

class MembersOnly extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    organization: PropTypes.shape({
      membershipDetails: PropTypes.shape({
        statusType: PropTypes.string,
        type: PropTypes.string,
      }),
    }),
    handleAssociateClick: PropTypes.func,
    handleJoinExistingOrg: PropTypes.func,
    currentUser: PropTypes.shape({
      id: PropTypes.string,
    }),
    event: PropTypes.shape({
      key: PropTypes.string,
    }),
  };
  static contentTypes = {
    orgExists: 'orgExists',
    memberOnly: 'memberOnly',
    associate: 'associate',
  };
  state = {
    content: MembersOnly.contentTypes.memberOnly,
  };

  closeAllDialogs = () => {
    this.props.closeDialog();
    this.setState({ content: MembersOnly.contentTypes.memberOnly });
  }

  render() {
    const { content } = this.state;
    const {
      title = '',
      text = '',
      organization,
      currentUser = {},
      event: { key: eventKey } = {},
      handleJoinExistingOrg,
      handleAssociateClick,
    } = this.props;
    const {
      membershipDetails: { statusType, type: memberType } = {},
    } = organization || {};

    if (content === MembersOnly.contentTypes.associate) {
      return (
        <CardText>
          <AssociationForm
            title="Associate With an Organization"
            closeDialog={() => this.closeAllDialogs()}
          />
          <Button
            style={{
              width: '100%',
              marginTop: '8px',
              marginLeft: '0px',
              marginRight: '0px',
            }}
            raised
            label="Cancel"
            onClick={() =>
              this.setState({ content: MembersOnly.contentTypes.memberOnly })}
          />
        </CardText>
      );
    }

    if (content === MembersOnly.contentTypes.orgExists) {
      return (
        <CardText>
          {'You have a record in our system. Please call NFIB Member ' +
            'Care at 1-800-NFIB-NOW to process your request. Thank you!'}
          <Button
            style={{
              width: '100%',
              marginTop: '30px',
              marginLeft: '0px',
              marginRight: '0px',
            }}
            raised
            label="Cancel"
            onClick={() =>
              this.setState({ content: MembersOnly.contentTypes.memberOnly })}
          />
        </CardText>
      );
    }

    return (
      <div>
        <CustomCardTitle>{title}</CustomCardTitle>
        <CardText>{text}</CardText>
        <CardActions style={{ flexDirection: 'column' }}>
          {/* JOIN: either does not have an org or has an org but is not any type of member */}
          {memberType !== 'Member' && memberType !== 'Associate'
            ? <Button
                label="Join NFIB as a member"
                style={{
                  width: '80%',
                  marginBottom: '2px',
                  marginRight: '0px',
                  marginLeft: '0px',
                  marginTop: '2px',
                }}
                onClick={() => {
                  if (
                    organization &&
                    organization.membershipDetails &&
                    memberType === 'None'
                  ) {
                    if (typeof handleJoinExistingOrg === 'function') {
                      handleJoinExistingOrg(
                        'You have a record in our system. Please call NFIB Member ' +
                          'Care at 1-800-NFIB-NOW to process your request. Thank you!'
                      );
                    } else {
                      this.setState({
                        content: MembersOnly.contentTypes.orgExists,
                      });
                    }
                  } else if (currentUser.id) {
                    window.location.href = `/redirect/join-existing?eventId=${eventKey}&cst=${currentUser.id}`;
                  } else {
                    window.location.href = `/redirect/join?eventId=${eventKey}`;
                  }
                }}
              />
            : null}
          {/* ASSOCIATE: if the user is registered/known but does not have an org */}
          {currentUser.id && !organization
            ? <Button
                style={{
                  width: '80%',
                  marginBottom: '2px',
                  marginRight: '0px',
                  marginLeft: '0px',
                  marginTop: '2px',
                }}
                label="Associate with an Organization"
                onClick={() => {
                  if (typeof handleAssociateClick === 'function') {
                    handleAssociateClick();
                  } else {
                    this.setState({
                      content: MembersOnly.contentTypes.associate,
                    });
                  }
                }}
              />
            : null}
          {/* RENEW: if we have an id and know the membership is lapsed */}
          {currentUser.id &&
            (memberType === 'Member' || memberType === 'Associate') &&
            statusType === 'Lapsed'
            ? <Button
                label="Renew your NFIB membership"
                style={{
                  width: '80%',
                  marginBottom: '2px',
                  marginRight: '0px',
                  marginLeft: '0px',
                  marginTop: '2px',
                }}
                onClick={() =>
                  window.location.href = `/redirect/renew?eventId=${eventKey}&cst=${currentUser.id}`}
              />
            : null}
        </CardActions>
      </div>
    );
  }
}

export default MembersOnly;



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/MembersOnly.js